import { useEffect } from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

/**
 * Dynamically updates the <html lang> attribute based on selected language.
 * Important for accessibility and SEO.
 */
const HtmlLangUpdater = () => {
  const { language } = useLanguage();

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return null;
};

export default HtmlLangUpdater;
